import { Box, styled, SxProps } from "@mui/material";
import { FC, Fragment, ReactNode } from "react";

const Wrapper = styled(Box)(({ theme }) => ({
  paddingLeft: "2.5rem",
  paddingRight: "2.5rem",
  transition: "all 0.3s",
  [theme.breakpoints.down(1200)]: {
    width: "100%",
    marginLeft: 0,
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
}));

const InnerWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: { maxWidth: 1280, margin: "auto" },
}));

type LayoutBodyWrapperProps = {
  sx?: SxProps;
  children: ReactNode;
};

const LayoutBodyWrapper: FC<LayoutBodyWrapperProps> = ({ children, sx }) => {
  return (
    <Fragment>
      <Wrapper sx={sx}>
        <InnerWrapper>{children}</InnerWrapper>
      </Wrapper>
    </Fragment>
  );
};

export default LayoutBodyWrapper;
